const coerceBoolean = (value: unknown) => {
  const stringValue = String(value)?.toLowerCase()?.trim();
  return stringValue === "true" || stringValue === "1";
};

export { coerceBoolean };
